import {
  CustomLabel,
  CustomModal,
  CustomTextArea,
} from '../../../../components';

interface IModalConfirm {
  isShow: boolean;
  handleModalConfirm?: (opc: boolean) => void;
  onSave: () => void;
  formik: any;
}
const ModalConfirm = ({
  isShow,
  handleModalConfirm,
  onSave,
  formik,
}: IModalConfirm) => {
  return (
    <CustomModal
      centered
      open={isShow}
      title=""
      width={1000}
      onSave={onSave}
      labelSubmit="Aceptar"
      onCancel={() => handleModalConfirm?.(false)}
      disabledBtn={!formik.isValid}
    >
      <CustomLabel
        level={4}
        align="center"
        text="¿Desea anular la solicitud?"
      />
      <CustomTextArea
        label="Observaciones"
        name="observations"
        value={formik.values.observations}
        error={formik.errors.observations}
        touched={formik.touched.observations}
        onChange={(value) => {
          formik.setFieldValue('observations', value.target.value);
        }}
        onBlur={formik.handleBlur}
      />
    </CustomModal>
  );
};

export default ModalConfirm;
